import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import {
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  ChevronCircleIcon,
} from "components/ui/ChevronAccordion";

import { DisbursementTable } from "./DisbursementTable";
import { MediumSpacer } from "components/ui/VerticalSpacers";
import { Columns, columnShape } from "./Columns";

export function ItemDetails({ item, messageEstDisbursements, showDecimals }) {
  const {
    title,
    subtitle,
    leftColumn,
    rightColumn,
    subItems: { termDetails = [], awardMessage },
  } = item;

  return (
    <AwardAccordionItem>
      {({ hoverActive, setHoverActive }) => (
        <>
          <AwardItemSummary>
            <AwardAccordionButton
              hoverActive={hoverActive}
              setHoverActive={setHoverActive}
            >
              <div>
                <div className="title">{title}</div>
                <div className="subtitle">{subtitle}</div>
              </div>

              <ChevronCircleIcon />
            </AwardAccordionButton>

            <MediumSpacer />
            <Columns
              right={rightColumn}
              left={leftColumn}
              showDecimals={showDecimals}
            />
          </AwardItemSummary>

          <AwardAccordionPanel>
            {termDetails.length > 0 && (
              <>
                <MediumSpacer />
                <DisbursementTable
                  termDetails={termDetails}
                  messageEstDisbursements={messageEstDisbursements}
                  showDecimals={showDecimals}
                />
              </>
            )}

            {awardMessage && (
              <>
                <MediumSpacer />
                <div>
                  <strong>Award Details</strong>
                  <div>{awardMessage}</div>
                </div>
              </>
            )}
          </AwardAccordionPanel>
        </>
      )}
    </AwardAccordionItem>
  );
}

ItemDetails.displayName = "ItemDetails";
ItemDetails.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    leftColumn: columnShape,
    rightColumn: columnShape,
    subItems: PropTypes.shape({
      awardMessage: PropTypes.string,
      authFailedMessage: PropTypes.string,
      termDetails: PropTypes.array,
    }),
  }),
  messageEstDisbursements: PropTypes.string,
  showDecimals: PropTypes.bool,
};

const AwardItemSummary = styled.div`
  padding: var(--sm) var(--md) var(--sm) var(--md);
`;

const AwardAccordionItem = styled(AccordionItem)`
  border-top: 1px solid var(--gallery);

  &:last-child {
    border-bottom: 1px solid var(--gallery);
  }
`;

const AwardAccordionButton = styled(AccordionButton)`
  padding: 0;
  display: flex;
  justify-content: space-between;
  line-height: 1.6;

  .title {
    font-size: var(--small-font-size);
  }

  .subtitle {
    font-size: 12px;
    color: var(--dove-gray);
  }
`;

const AwardAccordionPanel = styled(AccordionPanel)`
  padding: var(--md);
`;
